import {
  SystemTypeEnum,
  SystemTypeIdEnum,
} from 'src/app/domain/registration/enums/system-type.enum';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';
import { SystemIndexSelectComponent } from '../../systems/crud-index/crud-index-select.component';
import { PlanSelectionWizardComponent } from '../../plans/plan-selection-wizard/plan-selection-wizard.component';

export const RELATIVE_URL = 'plan-items';

export const COLUMNS_TO_SHOW_WEB = [
  'code',
  'planName',
  'terminalQuantity',
  'monthlyValue',
  'adhesionFee',
  'daysCountQuantity',
  'daysCountValue',
  'deploymentValue',
  'dueDate',
  'createdAt',
  'active',
  'remove',
];

export const CES_CONFIG_FIELDS = [
  // id - hidden
  {
    type: TypeComponentFieldEnum.HIDDEN,
    name: 'id',
  },

  {
    type: TypeComponentFieldEnum.HIDDEN,
    name: 'type',
  },
  { type: TypeComponentFieldEnum.INPUT, label: 'Código', name: 'code' },
  /*
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'TIPO',
    name: 'type',
    value: SystemTypeEnum.SYSTEM,
    options: ['', ...Object.values(SystemTypeEnum)],
  },
  */
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'Qtd. de terminais',
    name: 'terminalQuantity',
    placeholder: 'Insira a quantidade de terminais',
    value: '',
    options: [],
  },
  {
    type: TypeComponentFieldEnum.INPUT_CURRENCY,
    label: 'Mensalidade',
    name: 'monthlyValue',
    placeholder: 'Insira o valor mensal',
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'Dia de vencimento',
    name: 'dueDate',
    placeholder: 'Dia do mês (1 a 31)',
  },
  {
    type: TypeComponentFieldEnum.INPUT_CURRENCY,
    label: 'Taxa de adesão',
    name: 'adhesionFee',
    placeholder: 'Insira a taxa de adesão',
  },
  {
    type: TypeComponentFieldEnum.INPUT_NUMBER,
    label: 'Dias corridos',
    name: 'daysCountQuantity',
    placeholder: 'Insira os dias corridos',
  },
  {
    type: TypeComponentFieldEnum.INPUT_CURRENCY,
    label: 'Implantação',
    name: 'deploymentValue',
    placeholder: 'Insira o valor de implantação',
  },
  {
    type: TypeComponentFieldEnum.INPUT_NUMBER,
    label: 'Máx. de filiais',
    name: 'maxBranches',
    placeholder: 'Limite de filiais (opcional)',
  },
  {
    type: TypeComponentFieldEnum.INPUT_NUMBER,
    label: 'Máx. de usuários',
    name: 'maxUsers',
    placeholder: 'Limite de usuários (opcional)',
  },
  {
    type: TypeComponentFieldEnum.OBJECT,
    name: 'customerPlanAudits',
  },
  {
    type: TypeComponentFieldEnum.CANCEL_SAVE,
    labelSave: 'Salvar',
    labelCancel: 'Cancelar',
    name: 'cancelSave',
  },
  {
    type: TypeComponentFieldEnum.SLIDE_TOGGLE,
    label: 'Comissão unitária',
    name: 'isUnitCommission',
  },
];
